const RANGE_SEPARATOR = " - ";
export {
  RANGE_SEPARATOR
};
//# sourceMappingURL=constants.js.map
